module.exports = __webpack_public_path__ + "static/media/mobile-wheat.418cc587.png";